import { FlashResolveView } from './FlashResolve.view'

export const FlashResolve = () => {
  return <FlashResolveView />
}
